// extracted by mini-css-extract-plugin
export var button = "Button-module--button--19a9f";
export var flat = "Button-module--flat--06178";
export var normal = "Button-module--normal--ac0b1";
export var primary = "Button-module--primary--2f269";
export var secondary = "Button-module--secondary--8fa60";
export var small = "Button-module--small--2dd64";